import { css } from '@emotion/react';

const makePrivacyPolicyStyling = (theme) => {
  return {
    text: css({
      fontSize: theme.mvf.fontSize.little,
      [theme.breakpoints.up('tabletSmall')]: {
        fontSize: theme.mvf.fontSize.mini,
      },
    }),
    link: css({
      color: theme.mvf.palette.text.secondaryTextColor,
      cursor: 'pointer',
      textDecoration: 'underline',
      paddingTop: 0,
    }),
    lock: css({
      fontSize: theme.mvf.fontSize.little,
      [theme.breakpoints.up('tabletSmall')]: {
        fontSize: theme.mvf.fontSize.mini,
      },
      color: theme.mvf.palette.text.secondaryTextColor,
      marginRight: theme.mvf.spacing.tiny,
      position: 'relative',
      top: '2px',
    }),
  };
};

export default makePrivacyPolicyStyling;
